import React, { Fragment, useEffect, useState } from 'react';
import { string } from 'prop-types';
import axios from 'axios';

import FullSizeLoader from '../../react-components/full-size-loader';
import SelectDropdown from '../../react-components/select-dropdown';
import List from './list';
import Pager from '../../react-components/pagination/pager';

import { constEvent } from '../../utils/constants';

const ChangeAddress = ({
  endpointGetAddresses,
  endpointSaveCart,
  labelTitle,
  labelDescription,
  labelDefaultTag,
  labelBtnUseThisAddress,
  labelBtnCurrentlySelected,
  labelLinkSaveAndAddNew,
  hrefLinkSaveAndAddNew,
  labelPaginationShowPerPage,
  labelPaginationPrev,
  labelPaginationNext,
  paginationItemsPerPageOptions,
  paginationItemsPerPage
}) => {
  const [showAddNewLink, setShowAddNewLink] = useState(false);
  const [showContent, setShowContent] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(paginationItemsPerPage);
  const [totalPages, setTotalPages] = useState(0);
  const [items, setItems] = useState([]);
  const [endpoints, setEndpoints] = useState({});
  const [errorMessage, setErrorMessage] = useState(null);
  const [cartId, setCartId] = useState(null);
  const [shipId, setShipId] = useState('');

  useEffect(() => {
    document.addEventListener(
      constEvent.SHOW_MODAL_CHANGE_ADDRESS,
      firstLoad.bind(this)
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setCurrentPage(data?.page);
    setItemsPerPage(`${data?.perPage}`);
    setTotalPages(data?.totalPages);
    setItems(data?.items);
    setEndpoints(data?.endpoints);
  }, [data]);

  const firstLoad = e => {
    const inkoved = e?.detail?.showAddNewLink || false;
    const getCartId = e?.detail?.cartId || null;
    const getShipId = e?.detail?.shipId || '';

    setShowContent(false);
    setShowAddNewLink(inkoved);
    setCartId(getCartId);
    setShipId(getShipId);

    fetchAddresses({ currentPage, itemsPerPage, shipId: getShipId });
  }; //firstLoad

  const fetchAddresses = ({ currentPage, itemsPerPage, shipId }) => {
    setIsLoading(true);
    const finalEndpoint = `${endpointGetAddresses}?page=${currentPage}&per_page=${itemsPerPage}&ship_id=${shipId}`;

    axios({
      method: 'get',
      url: finalEndpoint,
      headers: {
        'content-type': 'application/json'
      }
    })
      .then(response => {
        const { success, body, message } = response?.data || {};

        if (success) {
          setData(body);
        } else {
          setErrorMessage(message);
        }
      })
      .catch(error => setErrorMessage(error?.message))
      .finally(() => {
        setShowContent(true);
        setIsLoading(false);
      });
  }; //fetchAddresses

  const handleIsLoading = toggle => setIsLoading(toggle);

  const handleSaveAndAddNew = e => {
    e.preventDefault();
    setIsLoading(true);

    axios({
      method: 'post',
      url: endpointSaveCart,
      data: { cart_name: cartName() },
      headers: {
        'content-type': 'application/json'
      }
    })
      .then(response => {
        const { success, message } = response?.data || {};

        if (success) {
          window.location.href = hrefLinkSaveAndAddNew;
        }
      })
      .finally(() => setIsLoading(false));
  }; //handleSaveAndAddNew

  const handleChangeItemsPerPage = option => {
    fetchAddresses({
      currentPage,
      itemsPerPage: option?.value,
      shipId
    });
  }; //handleChangeItemsPerPage

  const handleChangePage = newPage => {
    fetchAddresses({ currentPage: newPage, itemsPerPage, shipId });
  }; //handleChangePage

  const cartName = () => {
    const d = new Date();
    const ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d);
    const mo = new Intl.DateTimeFormat('en', { month: 'short' }).format(d);
    const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);

    return `${da}${mo}${ye}`;
  }; //cartName

  const propsList = {
    labelDefaultTag,
    labelBtnUseThisAddress,
    labelBtnCurrentlySelected,

    items,
    endpoints,
    showAddNewLink,
    cartId,

    onIsLoading: handleIsLoading
  }; //propsList

  const propsItemsPerPage = {
    fieldLabel: labelPaginationShowPerPage,
    options: paginationItemsPerPageOptions
      ?.split?.(',')
      ?.map?.(p => ({ label: p, value: p })),
    value: { label: itemsPerPage, value: itemsPerPage },
    onChange: handleChangeItemsPerPage
  }; //propsItemsPerPage

  const propsPager = {
    labelPrev: labelPaginationPrev,
    labelNext: labelPaginationNext,
    current: currentPage,
    total: totalPages,
    onPageChange: handleChangePage
  }; //propsPager

  return (
    <div className="change-address">
      <h3 className="change-address__title">{labelTitle}</h3>
      <hr />
      {labelDescription ? (
        <p className="change-address__description">{labelDescription}</p>
      ) : null}

      <div className="change-address__addresses">
        {showContent ? (
          <Fragment>
            {errorMessage ? (
              <p dangerouslySetInnerHTML={{ __html: errorMessage }} />
            ) : (
              <Fragment>
                {isLoading ? <FullSizeLoader /> : null}

                <div className="change-address__cols-wrapper">
                  <div className="change-address__col-1"></div>
                  <div className="change-address__col-2">
                    <SelectDropdown {...propsItemsPerPage} />
                  </div>
                </div>

                <List {...propsList} />

                {totalPages > 1 ? (
                  <div className="change-address__pagination">
                    <Pager {...propsPager} />
                  </div>
                ) : null}

                {showAddNewLink && labelLinkSaveAndAddNew ? (
                  <span className="change-address__save-and-new">
                    <a
                      className="link"
                      href={hrefLinkSaveAndAddNew}
                      onClick={handleSaveAndAddNew}
                    >
                      {labelLinkSaveAndAddNew}
                    </a>
                  </span>
                ) : null}
              </Fragment>
            )}
          </Fragment>
        ) : (
          <FullSizeLoader />
        )}
      </div>
    </div>
  );
};

ChangeAddress.propTypes = {
  endpointGetAddresses: string.isRequired,
  endpointSaveCart: string.isRequired,
  labelTitle: string.isRequired,
  labelDescription: string,
  labelDefaultTag: string.isRequired,
  labelBtnUseThisAddress: string.isRequired,
  labelBtnCurrentlySelected: string.isRequired,
  labelLinkSaveAndAddNew: string,
  hrefLinkSaveAndAddNew: string.isRequired,
  labelPaginationShowPerPage: string.isRequired,
  labelPaginationPrev: string.isRequired,
  labelPaginationNext: string.isRequired,
  paginationItemsPerPageOptions: string.isRequired,
  paginationItemsPerPage: string.isRequired
};

export default ChangeAddress;
